import { Button, ButtonColor, ButtonVariant, LayoutWithSidebar } from "@swivl-mono/ui";
import EmbedsModel from "../../../Models/Embeds/Embeds.Model";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { SearchableSidebarLinksList } from "../../../Components/SidebarLink/SearchableSidebarLinksList";
import { RouterWorksheetData } from "../../../Components/Worksheets/Types/Worksheet.Interface";

export default function EmbedsView() {
  const embeds = EmbedsModel.useState((state) => state.embeds);
  useEffect(() => {
    EmbedsModel.load(false);
  }, []);

  let items: RouterWorksheetData[] = [];
  if (embeds) {
    items = Object.values(embeds).map((embed) => {
      return {
        to: `properties/page/chatbots/${embed.id}`,
        label: embed.name,
      }
    });
  }

  return (
    <LayoutWithSidebar
      sidebar={
        <>
          <SearchableSidebarLinksList
            prefix={""}
            suffix={""}
            items={items}
          />
          <Button
            variant={ButtonVariant.GHOST}
            onClickAsync={async () => await EmbedsModel.create()}
          >
            + Add Chatbot
          </Button>
        </>
      }
      contentNoPadding={true}
      content={<div className="p-5"><Outlet /></div>}
    />
  );
}
